import { Column, Row } from "@/components";
import {
  CompanyLogoUploadTile,
  CompanyProfileSectionTitle,
} from "@/components/companies/profile";

import { useGetCompanyFile } from "@/hooks/queries/useGetCompanyFile";
import { CompanyInformation } from "@/types";

export const CompanyLogosSection = ({
  companyName,
  companyInformation,
  logoSignedUrl,
}: {
  companyName: string;
  companyInformation: CompanyInformation | null;
  logoSignedUrl: string | null;
}) => {
  /* Database CRUD Operations */
  // Read
  const smallLogoFileId =
    companyInformation?.companyInformation.smallLogoCompanyFileId;
  const { data: smallLogo } = useGetCompanyFile({
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    companyFileId: smallLogoFileId || 0,
    enabled: !!smallLogoFileId,
  });

  /* Render */
  const render = () => {
    if (!companyInformation) return null;
    return (
      <Column className="gap-3">
        <CompanyProfileSectionTitle title="Company logos" />
        <Row className="items-start gap-4">
          <CompanyLogoUploadTile
            companyName={companyName}
            logoUrl={logoSignedUrl}
            hasLogo={!!companyInformation.companyInformation.logoCompanyFileId}
          />
          <CompanyLogoUploadTile
            companyName={companyName}
            logoUrl={smallLogo?.signedUrl}
            hasLogo={!!smallLogoFileId}
            isSmallLogo
          />
        </Row>
      </Column>
    );
  };
  return render();
};
